define('mhi_kitcart.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('mhi_kitcart', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"kit-subitems\"></div>";
},"useData":true}, 'extensions/MHI/KitSubItems/1.0.0/', 'extensions/MHI/KitSubItems/1.0.0/', Handlebars);
});